import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { useSeo } from "@/lib/seo";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { applySession } = useAuth();
  useSeo({ title: "Vérification e-mail", robots: "noindex,nofollow" });
  const { t } = useLang();
  const navigate = useNavigate();
  const [status, setStatus] = useState("progress"); // progress | success | error
  const [msg, setMsg] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { setStatus("error"); setMsg(t("verify_error")); return; }
    api.post("/auth/verify-email", { token })
      .then(({ data }) => {
        applySession(data);
        setStatus("success");
        setTimeout(() => navigate("/account"), 1200);
      })
      .catch((err) => { setStatus("error"); setMsg(formatApiErrorDetail(err.response?.data?.detail) || t("verify_error")); });
  }, [token, applySession, navigate, t]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-6 text-center" data-testid="verify-email">
      {status === "progress" && <p className="text-anthracite/60">{t("verify_progress")}</p>}
      {status === "success" && (
        <div>
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-champagne text-2xl text-white">✓</div>
          <h1 className="font-serif text-3xl text-anthracite">{t("verify_success")}</h1>
        </div>
      )}
      {status === "error" && (
        <div>
          <h1 className="font-serif text-3xl text-anthracite">{msg || t("verify_error")}</h1>
          <Link to="/login" className="mt-4 inline-block text-sm text-champagne underline">{t("member_login")}</Link>
        </div>
      )}
    </div>
  );
}
